import React from "react"

export const buildAyudaStats = (statsData) => {
  const data = statsData?.data?.data ?? {}
  return [
    {
      label: "Total Ayuda Programs",
      value: data.total_ayuda_programs ?? 0,
      bgColor: "bg-green-100",
      textColor: "text-green-600",
      description: "Total assistance programs on record",
    },
    {
      label: "Active Distributions",
      value: data.approved_beneficiaries ?? 0,
      bgColor: "bg-blue-100",
      textColor: "text-blue-600",
      description: "Ongoing aid distribution activities",
    },
    {
      label: "Pending Assistance",
      value: data.pending_beneficiaries ?? 0,
      bgColor: "bg-orange-100",
      textColor: "text-orange-600",
      description: "Beneficiaries awaiting releases or validation",
    },
    {
      label: "Total Beneficiaries",
      value: data.total_beneficiaries ?? 0,
      bgColor: "bg-indigo-100",
      textColor: "text-indigo-600",
      description: "Individuals or households assisted",
    },
  ]
}

export const tableData = [
  {
    id: 1,
    created_at: "2026-01-25 10:30 AM",
    user_name: "Admin User",
    action: "CREATE",
    details: "Created Ayuda Program",
  },
  {
    id: 2,
    created_at: "2026-01-25 11:15 AM",
    user_name: "Staff User",
    action: "UPDATE",
    details: "Updated coverage regions",
  },
  {
    id: 3,
    created_at: "2026-01-26 09:00 AM",
    user_name: "Admin User",
    action: "DELETE",
    details: "Removed beneficiary",
  },
]

{
  /* <label className='relative inline-flex items-center cursor-pointer'>
                    <div
                      className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300 ${
                        status === "0" ? "bg-blue-500" : "bg-gray-500"
                      } ${className}`}
                      onClick={handleToggle}
                      role='switch'
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          handleToggle()
                          e.preventDefault()
                        }
                      }}
                    >
                      <div
                        className={`bg-white w-4 h-4 rounded-full shadow-md transform cursor-pointer transition-transform duration-300 ${
                          status === "0" ? "translate-x-6" : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                    <span className='ml-3 text-sm font-medium text-gray-700'>
                      Per HouseHold
                    </span>
                  </label> */
}
export const residentData = [
  {
    name: "Juan Dela Cruz",
    age: 32,
    gender: "Male",
    civil_status: "Married",
    monthly_income: 25000,
    phone: "0917-123-4567",
    email: "juan.delacruz@gmail.com",
    address: "Purok 1, Barangay San Isidro, Quezon City",
  },
  {
    name: "Maria Santos",
    age: 28,
    gender: "Female",
    civil_status: "Single",
    monthly_income: 18000,
    phone: "0928-456-7890",
    email: "maria.santos@gmail.com",
    address: "Purok 3, Barangay Mabini, Makati City",
  },
  {
    name: "Pedro Reyes",
    age: 45,
    gender: "Male",
    civil_status: "Married",
    monthly_income: 42000,
    phone: "0998-234-5678",
    email: "pedro.reyes@gmail.com",
    address: "Purok 2, Barangay Maligaya, Pasig City",
  },
  {
    name: "Ana Lopez",
    age: 21,
    gender: "Female",
    civil_status: "Single",
    monthly_income: 12000,
    phone: "0906-987-6543",
    email: "ana.lopez@gmail.com",
    address: "Purok 5, Barangay Sta. Cruz, Manila",
  },
  {
    name: "Carlos Mendoza",
    age: 60,
    gender: "Male",
    civil_status: "Widowed",
    monthly_income: 15000,
    phone: "0915-555-8899",
    email: "carlos.mendoza@gmail.com",
    address: "Purok 4, Barangay Del Pilar, Caloocan City",
  },
]
export const statusStyles = {
  completed: "bg-green-100 text-green-700",
  ongoing: "bg-blue-100 text-blue-700",
  pending: "bg-yellow-100 text-yellow-700",
}
// export const formatAmount = (amount) => {
//   if (!amount) return "—"
//   return `₱${Number(amount).toLocaleString()}`
// }

export const formatAmount = (amount) => {
  if (amount === null || amount === undefined || amount === "") return "—";

  const num = Number(String(amount).replace(/,/g, ""));
  if (isNaN(num)) return "—";

  return `₱${num.toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return "—"
  const date = new Date(dateString)
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  })
}

export const ayudaResidentColumns = [
  {
    key: "name",
    label: "Name",
  },
  {
    key: "contact_number",
    label: "Contact Number",
  },
  {
    key: "province",
    label: "Province",
  },
  {
    key: "municipality",
    label: "Municipality",
  },
  {
    key: "barangay",
    label: "Barangay",
  },
  {
    key: "status",
    label: "Status",
    render: (value) => (
      <span
        className={`px-2 py-1 rounded-full text-xs ${
          value === "received"
            ? "bg-green-100 text-green-700"
            : "bg-yellow-100 text-yellow-700"
        }`}
      >
        {value}
      </span>
    ),
  },
]
export const capitalize = (str) => {
  if (!str) return ""
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

import { EyeIcon } from "@heroicons/react/24/outline"

export const ayudaProgramColumns = (
  navigate,
  formatAmount,
  formatDate,
  meta
) => [
  {
    key: "title",
    label: "Program Name",
    render: (_, program) => (
      <div>
        <div className='text-sm font-medium text-gray-900'>{program.title}</div>
        <div className='text-sm text-gray-500 truncate max-w-xs'>
          {program.description}
        </div>
      </div>
    ),
  },
  {
    key: "amount",
    label: "Amount",
    render: (value) => (
      <span className='text-sm font-medium text-gray-900'>
        {formatAmount(value)}
      </span>
    ),
  },
  {
    key: "coverage",
    label: "Coverage",
    render: (_, program) => (
      <span className='text-sm text-gray-900'>
        {program.coverage === true
          ? "National"
          : program.coverage === false
          ? "Selected Areas"
          : program.is_national === 1
          ? "National"
          : "Selected Areas"}
      </span>
    ),
  },
  {
    key: "is_per_household",
    label: "Type",
    render: (value) => (
      <span className='text-sm text-gray-900'>
        {value === 1 ? "Per Household" : "Per Individual"}
      </span>
    ),
  },
  {
    key: "created_at",
    label: "Date",
    render: (_, program) => (
      <span className='text-sm text-gray-900'>
        {formatDate(program.created_at || program.date)}
      </span>
    ),
  },
  {
    key: "status",
    label: "Status",
    render: (status) => (
      <span
        className={`px-3 py-1 text-xs font-medium rounded-full ${
          statusStyles[status] || "bg-gray-100 text-gray-600"
        }`}
      >
        {status?.charAt(0).toUpperCase() + status?.slice(1)}
      </span>
    ),
  },
  {
    key: "actions",
    label: "Actions",
    render: (_, program) => (
      <button
        onClick={() =>
          navigate(`/ayuda/${program.id}`, {
            state: program,
            meta,
          })
        }
        className='text-blue-600 hover:text-blue-900 transition-colors'
        title='View Details'
      >
        <EyeIcon className='h-5 w-5' />
      </button>
    ),
  },
]
// added
export const computeDisbursementStats = (recipients = []) => {
  const total = recipients.length

  const released = recipients.filter((r) => {
    const status = r.status?.toLowerCase()
    return status === "released" || status === "received" || status === "completed"
  }).length

  const pending = total - released
  const progress = total ? Math.round((released / total) * 100) : 0

  return { total, released, pending, progress }
}
